/**
 * Конфигурация навигации admin-app.
 *
 * 12 групп дизайна v4, сгруппированы по фиче в порядке UX-потока роли
 * platform_admin: вход → ежедневные операции (дашборд, онбординг, отели,
 * подписки) → управление доступом → мониторинг → отчёты → настройки.
 *
 * Один источник правды для бокового меню и для регистрации маршрутов.
 */

export interface NavItem {
  /** Абсолютный путь маршрута. */
  path: string;
  /** Подпись в меню (RU). */
  label: string;
  /** Группа дизайна v4 (для тестов/группировки в отчёте). */
  group: string;
}

export const NAV_ITEMS: ReadonlyArray<NavItem> = [
  { path: '/dashboard', label: 'Дашборд', group: 'Дашборд' },
  { path: '/onboarding', label: 'Онбординг отеля', group: 'Онбординг' },
  { path: '/hotels', label: 'Отели', group: 'Отели' },
  { path: '/subscriptions', label: 'Подписки и биллинг', group: 'Подписки' },
  { path: '/rbac', label: 'Пользователи и RBAC', group: 'RBAC' },
  { path: '/capabilities', label: 'Capability', group: 'Capability' },
  { path: '/audit', label: 'Аудит и проверка цепочки', group: 'Аудит' },
  { path: '/vendors', label: 'Поставщики', group: 'Поставщики' },
  { path: '/reviews', label: 'Модерация отзывов', group: 'Отзывы' },
  { path: '/health', label: 'Здоровье платформы', group: 'Мониторинг' },
  { path: '/reports', label: 'Отчёты', group: 'Отчёты' },
  { path: '/settings', label: 'Настройки', group: 'Настройки' },
] as const;
